import { useEffect, useState } from "react";
import { CONSENT_CHANGE_EVENT, canLoadMarketing } from "@/lib/utils/consent";
import { loadMetaPixel, revokeMetaPixel } from "@/lib/utils/metaPixel";

/** Loads the Meta Pixel only while the visitor has accepted marketing cookies. */
export function MetaPixelManager() {
  const [marketingEnabled, setMarketingEnabled] = useState(canLoadMarketing);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const handleConsentChange = () => {
      setMarketingEnabled(canLoadMarketing());
    };

    window.addEventListener(CONSENT_CHANGE_EVENT, handleConsentChange as EventListener);
    window.addEventListener("storage", handleConsentChange);

    return () => {
      window.removeEventListener(CONSENT_CHANGE_EVENT, handleConsentChange as EventListener);
      window.removeEventListener("storage", handleConsentChange);
    };
  }, []);

  useEffect(() => {
    if (marketingEnabled) {
      loadMetaPixel();
    } else {
      revokeMetaPixel();
    }
  }, [marketingEnabled]);

  return null;
}
